import { defineStore } from 'pinia'
import { computed } from 'vue'
import { useNuxtApp } from '#app'
import { useSyncData } from '@/composables/useSyncData'
import { useAuthStore } from '@/stores/useAuthStore'
import type { ChargeModel } from '@/_api/models/chargeModel'

export const useChargeModelStore = defineStore('chargeModel', () => {
  const { $api, $grants } = useNuxtApp()
  const authStore = useAuthStore()

  const accountId = computed(() => authStore.activeGuid)

  const {
    items,
    count,
    hydrated,
    syncState,
    isSyncing,
    syncProgress,
    sync: _sync,
    findById,
  } = useSyncData<ChargeModel>({
    service: $api.chargeModel,
    key: 'chargeModel',
    accountId,
    grants: { chargeModel: ['view'] },
  })

  const sync = async (options?: { force?: boolean; change?: boolean }) => {
    if (!$grants.all({ chargeModel: ['view'] })) {
      return
    }

    await _sync(options)
  }

  const all = computed(() => items.value)
  const syncDate = computed(() => syncState.value.date)

  return {
    items,
    count,
    hydrated,
    syncState,
    isSyncing,
    syncProgress,
    syncDate,
    sync,
    findById,
    all,
  }
})
